export const StatusTranslations = [
  {
    name: "CREATING",
    translation: "Creando",
  },
  {
    name: "SEARCHING",
    translation: "Buscando",
  },
  {
    name: "ACCEPTED",
    translation: "Aceptado",
  },
  {
    name: "STARTED",
    translation: "Iniciado",
  },
  {
    name: "ARRIVED",
    translation: "Conductor llego",
  },
  {
    name: "PICKEDUP",
    translation: "Abordado",
  },
  {
    name: "DROPPED",
    translation: "En destino",
  },
  {
    name: "TRAVELING",
    translation: "En viaje",
  },
  {
    name: "CANCELLED",
    translation: "Cancelado",
  },
  {
    name: "SCHEDULED",
    translation: "Agendado",
  },
  {
    name: "COMPLETED",
    translation: "Completado",
  },
  {
    name: "FINISHED",
    translation: "Finalizado",
  },
];

interface Props {
  name: string;
  translation: string;
}
interface IndexST {
  [key: string]: Props;
}

export const IndexStatusTranslations: IndexST = {
  CREATING: {
    name: "CREATING",
    translation: "Creando",
  },
  SEARCHING: {
    name: "SEARCHING",
    translation: "Buscando",
  },
  ACCEPTED: {
    name: "ACCEPTED",
    translation: "Aceptado",
  },
  STARTED: {
    name: "STARTED",
    translation: "Iniciado",
  },
  ARRIVED: {
    name: "ARRIVED",
    translation: "Conductor llego",
  },
  PICKEDUP: {
    name: "PICKEDUP",
    translation: "Abordado",
  },
  DROPPED: {
    name: "DROPPED",
    translation: "En destino",
  },
  TRAVELING: {
    name: "TRAVELING",
    translation: "En viaje",
  },
  CANCELLED: {
    name: "CANCELLED",
    translation: "Cancelado",
  },
  SCHEDULED: {
    name: "SCHEDULED",
    translation: "Agendado",
  },
  COMPLETED: {
    name: "COMPLETED",
    translation: "Completado",
  },
  FINISHED: {
    name: "FINISHED",
    translation: "Finalizado",
  },
  CREATED: {
    name: "CREATED",
    translation: "Nuevo",
  },
};

export const StatusColors: Record<string, string> = {
  SEARCHING: "#1976d2",
  SCHEDULED: "#ed6c02",
  STARTED: "#1976d2",
  CANCELLED: "#d32f2f",
  COMPLETED: "#2e7d32",
  ACCEPTED: "#1976d2",
  ARRIVED: "#1976d2",
  CREATED: "#1976d2",
  PICKEDUP: "#1976d2",
  DROPPED: "#2e7d32",
  TRAVELING: "#1976d2",
  FINISHED: "#2e7d32",
};
